/* eslint-disable indent */
import { observer } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useEffect, useRef, useState } from 'react';

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FormatNumber } from '../../../../../../components';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './style.scss';

const PriceSlideComponent = observer(({ slides }) => {
    // ref
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const breakpoints = {
        480: {
            slidesPerView: 1,
            slidesPerGroup: 1
        },
        768: {
            slidesPerView: 2,
            slidesPerGroup: 2
        },
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3
        }
    };

    const [isPc, setIsPc] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        const onResize = () => setIsPc(window.innerWidth >= 1024);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const hiddenNavigation = isPc && slides.length <= 3;

    return (
        <div className="ticket-slide-wrapper">
            <Swiper
                onInit={(swiper) => {
                    setTimeout(() => {
                        if (swiper.params?.navigation) {
                            if (typeof swiper.params.navigation !== 'boolean') {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }
                        }
                    });
                }}
                slidesPerView={1}
                slidesPerGroup={1}
                spaceBetween={30}
                breakpoints={breakpoints}
                modules={[Pagination, Navigation]}
                pagination={{
                    clickable: true,
                    el: '.ticket-custom-pagination'
                }}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }}
                className="ticket-swiper-sample"
            >
                {Array.isArray(slides) &&
                    slides?.length > 0 &&
                    slides.map((slide, index) => (
                        <SwiperSlide key={slide?.id}>
                            <TicketCard ticketItem={slide} index={index} />
                        </SwiperSlide>
                    ))}
            </Swiper>

            {/* Custom Navigation */}
            <div className="ticket-custom-navigation">
                {!hiddenNavigation && (
                    <>
                        <button
                            ref={prevRef}
                            className="custom-nav-button custom-nav-prev"
                            aria-label="Previous slide"
                        >
                            <ChevronLeft strokeWidth={2.25} color='#FFF' />
                        </button>

                        <div className="ticket-custom-pagination"></div>

                        <button
                            ref={nextRef}
                            className="custom-nav-button custom-nav-next"
                            aria-label="Next slide"
                        >
                            <ChevronRight strokeWidth={2.25} color='#FFF' />
                        </button>
                    </>
                )}
            </div>
        </div>
    )
})

export default PriceSlideComponent;

const TicketCard = observer(({ ticketItem, index }) => {
    const getClassNameForTicketCard = (index, type, suffix) => {
        if (type === 'bg') {
            switch (index % 3) {
                case 0:
                    return `ticket-bg-primary ${suffix}`;
                case 1:
                    return `ticket-bg-secondary ${suffix}`;
                case 2:
                    return `ticket-bg-tertiary ${suffix}`;
                default:
                    return `ticket-bg-primary ${suffix}`;
            }
        } else {
            switch (index % 3) {
                case 0:
                    return `ticket-text-primary ${suffix}`;
                case 1:
                    return `ticket-text-secondary ${suffix}`;
                case 2:
                    return `ticket-text-tertiary ${suffix}`;
                default:
                    return `ticket-text-primary ${suffix}`;
            }
        }
    }

    const showTimeStudy = (time) => {
        const countMonths = 12;
        const numberTime = parseInt(time);

        if (isNaN(numberTime) || numberTime <= 0) {
            return (
                <>
                    <FormatNumber value={time} />
                    カ月
                </>
            );
        }

        const quotient = Math.floor(numberTime / countMonths);
        const remainder = numberTime % countMonths;

        return (
            <>
                {quotient > 0 && (
                    <>
                        <FormatNumber value={quotient} />年間
                    </>
                )}
                {remainder > 0 && (
                    <>
                        <FormatNumber value={remainder} />カ月
                    </>
                )}
            </>
        );
    };

    return (
        <div className="swiper-slide ticket-card-container">
            <div className="item ticket-card">
                <h3 className={getClassNameForTicketCard(index, 'bg')}>
                    <div className="name-ticket">{ticketItem?.name}</div>
                    <div style={{ fontSize: 20 }}>
                        （
                        {ticketItem?.amount !== null ? (
                            <>
                                <FormatNumber value={ticketItem?.amount} />
                                講座
                            </>
                        ) : (
                            '無制限'
                        )}
                        ）
                    </div>
                </h3>
                <div className="nav-item">
                    <p className={getClassNameForTicketCard(index, 'text', 'price price-ticket')}>
                        <span>
                            <FormatNumber
                                value={((ticketItem?.price || 0) * 11) / 10}
                            />

                        </span>
                        <span className="note-price-ticket">円（税込）</span>
                    </p>
                    <div className="ticket-info-detail">
                        {/* <p className="desc-1"> */}
                        <p className={getClassNameForTicketCard(index, 'text', 'ticket-detail')}>
                            <span>受講期間</span>
                            <span>
                                {/* <FormatNumber value={ticketItem?.duration} />
                                カ月 */}
                                {showTimeStudy(ticketItem?.duration)}
                            </span>
                        </p>
                    </div>
                    <p className="desc-2 height-desc-2 text-justify-inter-word">
                        {ticketItem?.description}
                    </p>
                </div>
            </div>
        </div>
    )
})
